import axios, { AxiosError, AxiosRequestConfig } from "axios";

const BACKEND_URL_AUTH = process.env.REACT_APP_AUTH_API_URL ?? "/";

export async function ConfirmDeviceCode(
    code: string,
    access_token: string,
    abortController: AbortController
): Promise<true | AxiosError> {
    try {
        await axios.post(
            BACKEND_URL_AUTH + "v1/device/confirm",
            { code },
            {
                signal: abortController.signal,
                headers: {
                    Authorization: "Bearer " + access_token,
                },
            } as AxiosRequestConfig
        );

        return true as const;
    } catch (err) {
        const error = err as AxiosError;
        console.log("ConfirmDeviceCode Error", error);
        return error;
    }
}
